import styled from 'styled-components';

export const SubNavWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: end;
  border-bottom: 1px solid #adadad;
`;

export const SubNavButtonActive = styled.div`
  padding: 0.5rem;
  font-weight: 600;
  color: rgb(75, 40, 109);
  border-bottom: 2px solid rgb(75, 40, 109);
  cursor: pointer;
`;

export const SubNavButton = styled.div`
  padding: 0.5rem;
  font-weight: ${props => (props.isSelected ? '600' : '500')};
  cursor: pointer;
  color: ${props =>
    props.isSelected ? 'rgb(75, 40, 109)' : 'rgb(103, 110, 115)'};
  border-bottom: ${props =>
    props.isSelected ? '2px solid rgb(75, 40, 109)' : '0'};
`;
